import React, { useContext } from "react";
import { Link } from "react-router-dom";
import toMovieUrl from "@functions/toMovieUrl";
import { SearchContext } from "@context/SearchContext";
import Loader from "@components/Ui/Loader";
import Slider from "@components/V3/Slider";
import VenueSelector from "@components/V3/VenueSelector";

import "./style.scss";

const MovieSlider = ({
                         title,
                         movies,
                         isLoading,
                         fallbackImage,
                         baseClass,
                         showVenueSelector = false,
                         getMovieTitle,
                         getMovieId,
                         getMovieImage,
                     }) => {
    const { venueName } = useContext(SearchContext);

    if (isLoading) {
        return <Loader isLoading={true} text="Fetching Movies" />;
    }

    if (!movies || !Array.isArray(movies) || movies.length === 0) {
        return (
            <div className="search__container">
                <p className="paragraph">Sorry, there are no movies available.</p>
            </div>
        );
    }

    return (
        <div className="movie-slider">
            <h2 className={`${baseClass}__title`}>{title}</h2>
            {showVenueSelector && <VenueSelector />}
            <Slider
                className={`${baseClass}__list`}
                wrapperClass={`${baseClass}__carousel`}
                arrowClass={`${baseClass}__arrow`}
            >
                {movies.map((movie, index) => {
                    const id = getMovieId(movie);
                    const name = getMovieTitle(movie);
                    const image = getMovieImage(movie) || fallbackImage;

                    if (!name) return null;

                    return (
                        <div className={`${baseClass}__wrapper`} key={id}>
                            <Link
                                className={`${baseClass}__link`}
                                to={toMovieUrl(id, name, venueName)}
                            >
                                <img
                                    className={`${baseClass}__image`}
                                    src={image}
                                    alt={name}
                                    width={428}
                                    height={642}
                                    loading={index < 4 ? "eager" : "lazy"}
                                    decoding="async"
                                    onError={(e) => {
                                        e.currentTarget.onerror = null;
                                        e.currentTarget.src = fallbackImage;
                                    }}
                                />
                            </Link>
                            <p className={`${baseClass}__movie-title`}>{name}</p>
                            <div className={`${baseClass}__info`}>
                                {movie.rating && (
                                    <div className={`${baseClass}__movie-rating ${baseClass}__movie-rating--${movie.rating.replace("+", "")}`}>
                                        {movie.rating}
                                    </div>
                                )}
                                {movie.running_time && (
                                    <div className={`${baseClass}__movie-time`}>
                                        {movie.running_time} min
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
};

export default MovieSlider;
